<template>
  <div class="role-page full-height">
    <full-con :canReturn='canReturn'>
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">物料名称:</div>
            <div class="flex1" >
              <div style="padding-top:5px">{{materialName}}</div>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">关联订单号:</div>
            <div class="flex1">
              <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.orderNo"
                  size="small"
                  @keyup.enter.native="searchMaterialRecord"
              >
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">物料单类别:</div>
            <div class="flex1">
              <el-select
                  v-model="queryInfo.materialRecordType"
                  placeholder="请选择"
                  size="small"
              >
                <el-option
                    v-for="item in typeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">创建开始日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.startTime"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">创建结束日:</div>
            <div class="flex1">
              <el-date-picker
                  clearable
                  v-model="queryInfo.endTime"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="18" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">

              <el-button
                  class="search-btn btn-gray"
                  @click="clearConditions"
              >重置</el-button
              >
              <el-button
                  class="search-btn btn-blue"
                  @click="searchMaterialRecord"
              >搜索</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="full">
        <div slot="table" class="full-height display-col">
          <el-table
              :data="materialRecordList"
              :header-cell-style="tableStyle.headerStyle"
              :cell-style="tableStyle.cellStyle"
              border
              >
            <el-table-column type="index" label="序号" align="center" id="40">
            </el-table-column>
            <el-table-column prop="materialNo" align="center" label="流水号">
            </el-table-column>
            <el-table-column
                prop="createTime"
                label="创建时间"
                align="center"
                width="150"

            >
              <template v-slot="scope">
                {{ scope.row.createTime | dateFormatToSecond }}
              </template>
            </el-table-column>
            <el-table-column prop="materialRecordType" align="center" label="类型" :formatter="typeFormatter">
            </el-table-column>
            <el-table-column prop="orderNo" align="center" label="关联订单号">
            </el-table-column>
            <el-table-column prop="amount" label="数量" align="center" :formatter="amountFormatter">
            </el-table-column>
            <el-table-column prop="residueAmount" align="center" label="剩余数量">
            </el-table-column>
            <el-table-column prop="price" align="center" label="价格">
            </el-table-column>
            <el-table-column prop="notes" label="备注">
            </el-table-column>
          </el-table>
          <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryInfo.pageNum"
              :page-sizes="[5, 10, 20, 50, 100]"
              :page-size="queryInfo.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
          ></el-pagination>
        </div>
      </div>
    </full-con>
  </div>
</template>

<script>
export default {

  data() {
    return{
      canReturn:'1',
      pageTitle:'物料流水',
      createDateRangeValue:[],
      materialName: "",
      typeOptions: [
        {
          value: "0",
          label: "同捆用料",
        },
        {
          value: "1",
          label: "装箱单用料",
        },
        {
          value: "2",
          label: "采购进料",
        },
      ],
      queryInfo: {
        materialId: 0,
        orderNo: "",
        startTime: "",
        endTime: "",
        materialRecordType: "",
        pageSize: 10,
        pageNum: 1,
      },
      materialRecordList: [],
      total: 0,
    };
  },
  watch:{
    //监听时间选择器绑定值变化
    createDateRangeValue(){
      //解决时间选择器清空后 绑定值为null问题
      if(!this.createDateRangeValue){
        this.createDateRangeValue = [];
        this.queryInfo.startTime = '';
        this.queryInfo.endTime = '';
      }
      else{
        if(this.createDateRangeValue.length>0){
          this.queryInfo.startTime = this.createDateRangeValue[0];
          this.queryInfo.endTime = this.createDateRangeValue[1];
        }
      }

    },
  },
  methods: {
    createDateRange(){
    },
    amountFormatter(row, colum) {
      let symbol = "";
      if (row.tradeType == "0") {
        symbol = "+";
      } else if (row.tradeType == "1") {
        symbol = "-";
      }
      return symbol + row.amount;
    },
    typeFormatter(row, column) {
      if (row.materialRecordType == "0") {
        return "同捆用料";
      } else if (row.materialRecordType == "1") {
        return "装箱单用料";
      } else if (row.materialRecordType == "2") {
        return "采购进料";
      }
    },
    searchMaterialRecord() {
      this.queryInfo.pageNum = 1;
      this.getMaterialRecordList();
    },
    handleSizeChange(pageSize) {
      this.queryInfo.pageSize = pageSize;
      this.getMaterialRecordList();
    },
    handleCurrentChange(pageNumber) {
      this.queryInfo.pageNum = pageNumber;
      this.getMaterialRecordList();
    },
    clearConditions() {
      this.queryInfo.orderNo = "";
      this.queryInfo.startTime = "";
      this.queryInfo.endTime = "";
      this.queryInfo.materialRecordType = "";
      console.log(this.createDateRangeValue)
      this.createDateRangeValue=[]
    },
    async getMaterialRecordList() {
      const { data: res } = await this.$http.get(
        "materialRecord/materialRecordList",
        {
          params: this.queryInfo,
        }
      );
      console.log(res);
      this.materialRecordList = res.data.list;
      this.total = res.data.total;
    },
  },

  created() {
    this.queryInfo.materialId = this.$route.query.materialId;
    this.materialName = this.$route.query.materialName;
    this.getMaterialRecordList();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}
.el-table .el-button--small {
  padding: 4px 10px;
}
</style>